module.exports = __webpack_public_path__ + "static/media/glitter.915b427d.png";